export default {
  translation: {
    'New surface': 'Neue Zelle',
    'Surface successfully updated': 'Zelle erfolgreich aktualisiert',
    'Surface successfully created': 'Zelle erfolgreich erstellt',
    'Successfully deleted node {{name}}': 'Dokument erfolgreich gelöscht',
    'Successfully copied nodes {{names}}': 'Elemente erfolgreich kopiert',
    'Successfully cut nodes {{names}}': 'Elemente erfolgreich schneiden',
    'Successfully deleted nodes {{names}}': 'Elemente erfolgreich gelöscht',
    'All elements in your clipboard': 'Alle Elemente in Ihrer Zwischenablage',
    'Clear clipboard': 'Zwischenablage löschen',
    'Insert copy': 'Kopie einfügen',
    'Insert synced copy': 'Synchronisierte Kopie einfügen',
    Judicature: 'Justiz',
    'Successfully created RIS node': 'Dokument erfolgreich gespeichert',
    'You have received and email to reset your password. Please check your email inbox and spam folder.':
      'Sie haben eine E-Mail erhalten um Ihr Passwort zurückzusetzen. Bitte überprüfen Sie Ihren E-Mail-Posteingang und Ihren Spam-Ordner.',
    Login: 'Login',
    'Please select a surface...': 'Bitte wählen Sie eine Zelle...',
    Submit: 'Speichern',
    Cancel: 'Abbrechen',
    Logout: 'Ausloggen',
    'Are you sure that you want to logout?':
      'Sind Sie sicher, dass Sie sich abmelden möchten?',
    'Are you sure that you want to delete?':
      'Sind Sie sicher, dass Sie löschen möchten?',
    Confirm: 'Bestätigen',
    'Select or drag file': 'Datei auswählen oder ziehen',
    'Results per page': 'Ergebnisse pro Seite',
    'name is required': 'Name ist erforderlich',
    'file is required': 'Datei ist erforderlich',
    'Name of document': 'Name des Dokuments',
    'Delete {{name}}': 'Löschen {{name}}',
    Delete: 'Löschen',
    'Select or drag {{types}} file':
      '{{types}} Datei auswählen oder hierher ziehen',
    'url is required': 'URL ist erforderlich',
    'text is required': 'Text ist erforderlich',
    'Type your text here...': 'Geben Sie Ihren Text hier ein...',
    'Delete note': 'Notiz löschen',
    'Search term is required': 'Suchbegriff ist erforderlich',
    'Search type is required': 'Suchtyp ist erforderlich',
    'RIS-Search': 'Rechtssuche',
    'Search for Reference number, Legal Summary, Paragraph or Article. Add relevant legal text to your personal DNN.':
      'Fügen Sie die rechtliche Grundlage in Form von Paragraphen, Artikel oder Geschäftszahlen ein.',
    'Select the type of search': 'Wählen Sie die Art der Suche',
    'Federal Law': 'Bundesgesetzblatt',
    'Federal Standards': 'Bundesrecht',
    'Type search term...': 'Geben Sie Ihre Suche hier ein',
    Search: 'Suche',
    'Reset password': 'Passwort zurücksetzen',
    'Invalid email format': 'ungültiges Email-Format',
    'Last name is required': 'Nachname ist erforderlich',
    'Please enter your email address used during registration':
      'Bitte geben Sie die bei der Registrierung genuzte E-Mailadresse ein.',
    'E-Mail': 'E-Mail',
    'Email is required': 'E-Mail ist erforderlich',
    'No password provided': 'Kein Passwort angegeben',
    'Passwords must match': 'Passwörter müssen übereinstimmen',
    'Password is too short - should be 5 chars minimum':
      'Das Passwort ist zu kurz - sollte mindestens 5 Zeichen betragen',
    Password: 'Passwort',
    'Confirm Password': 'Passwort bestätigen',
    'Remember me': 'Angemeldet bleiben',
    'Not registered?': 'Noch nicht registriert?',
    'Forgot password?': 'Passwort vergessen?',
    'Privacy policy': 'Datenschutz-Bestimmungen',
    'We process the personal data in accordance with the data protection regulations': {
      ' The legal basis for the processing is pivotal to fulfill a contract or to carry out pre-contractual measures (Art 6 (1) (b) GDPR), or to fulfill legal obligations to which we are subject (Art 6 (1) (c) GDPR)': {
        '\n\nIn addition, processing is completed by us or a third party due to legitimate interest': {
          ' E': {
            g: {
              ' for the protection of employees and customers, for the further development of our company, of products and services in order to win back customers in order to prevent or combat fraud, and/or to prosecute or defend against legal claims (Art': {
                ' 6 (1) (f) GDPR)': {
                  ' If you have given us your consent, the processing takes place for the stated purposes (Article 6 (1) (a) GDPR)': {
                    ' You can revoke your consent at any time without affecting the legality of the processing, carried out on the basis of the consent until the revocation': {
                      ' The revocation can be submitted by e-mail to gdpr@9y': {
                        co: {
                          '\n\nB': {
                            ' Storage of IP addresses\nWhen you visit our website, data is stored on our servers for backup purposes (such as IP address, call time and visited pages)': {
                              ' We process this data for data security reasons and to ensure the stability and reliability of our system': {
                                '\n\nC': {
                                  ' Cookies\nOur website uses so-called "cookies" which are text files that are stored on your computer': {
                                    ' Cookies allow us to analyze the overall use of the website by the use of individuals': {
                                      ' You can prevent the installation of cookies by setting your browser software accordingly': {
                                        ' However, please be aware that if you do this, you may not be able to use the full functionality of this website':
                                          '',
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    Accept: 'Akzeptieren',
    'Finish registration': 'Registrierung abschließen',
    'Your registration email has been sent. To finish up your registration verify your email address by checking your email inbox and spam folder.':
      'Ihre Registrierungs-E-Mail wird gesendet. Um Ihre Registrierung abzuschließen, überprüfen Sie bitte Ihren Posteingang (evtl. Spam-Ordner) und bestätigen Sie Ihre E-Mail-Adresse.',
    'Terms of Service': 'Nutzungsbedingungen',
    'First name is required': 'Vorname ist erforderlich',
    'You have to accept our terms of service':
      'Sie müssen unsere Nutzungsbedingungen akzeptieren',
    Registration: 'Registrierung',
    Register: 'Registrieren',
    'First name': 'Vorname',
    'Last name': 'Nachname',
    'I agree to the': 'Ich stimme den',
    'privacy policy': 'Datenschutzbestimmungen zu',
    'and the': 'und den',
    'terms of service': 'Datenschutzbestimmungen zu',
    'Already registered?': 'Bereits registriert?',
    'Your token has expired please login to continue.':
      'Ihr Token ist abgelaufen. Bitte melden Sie sich an, um fortzufahren',
    'Not Found': 'Nicht gefunden',
    'Name of note': 'Name der Notiz',
    'Sorry, but no records matched your query.':
      'Entschuldigung, aber keine Datensätze stimmten mit Ihrer Anfrage überein.',
    'Try changing your search parameters.':
      'Versuchen Sie, Ihre Suchparameter zu ändern.',
    'Sign in code': 'Anmeldecode',
    'Sign in code is required. If you have not received it please contact the support.':
      'Anmeldecode erforderlich. Wenn Sie es nicht erhalten haben, wenden Sie sich bitte an den Support.',
    Code: 'Code',
    'Create code': 'Code erstellen',
    'Back to list': 'Zurück zur Liste',
    'Create sign in code': 'Anmeldecode erstellen',
    'Used on': 'Benutzt auf',
    'Sign in URL': 'Anmelde-URL',
    'Successfully copied to clipboard':
      'Erfolgreich in die Zwischenablage kopiert',
    'Insert note': 'Notiz einfügen',
    Close: 'Schließen',
    'Note name': 'Name der Notiz',
    'Write down a description for the note…':
      'Schreiben Sie eine Beschreibung für die Notiz auf…',
    'Insert text field': 'Textfeld einfügen',
    'Update text field': 'Textfeld aktualisieren',
    Page: 'Seite',
    'Back to file upload': 'Zurück zum Upload',
    'Back to legal search': 'Zurück zur Rechtssuche',
    'Insert document': ' Dokument einfügen',
    'Legal Search': 'Rechtssuche',
    'Insert the legal basis in the form of paragraphs, articles or business figures.':
      'Belegen Sie Ihre Aussage rechtlich.',
    Judiciary: 'Justiz',
    'Federal Law Gazette': 'Bundesgesetzblatt',
    Paragraph: 'Absatz',
    Type: 'Art',
    'Effective date': 'Datum des Inkrafttretens',
    'Update note': 'Speichern',
    'Update document': 'Dokument aktualisieren',
    'Insert placeholder': 'Platzhalter einfügen',
    'Update placeholder': 'Platzhalter aktualisieren',
    'Name of protocol node': 'Name des Platzhalters',
    'Update cell': 'Zelle aktualisieren',
    'Insert cell': 'Zelle einfügen',
    'Enter surface name': 'Zelle benennen',
    'Save image': 'Datei speichern',
    'Update image': 'Update-Datei',
    'Back to {{surface}}': 'Zurück zu {{surface}}',
    '{{count}} Link(s) with': '{{count}} Link(s) mit',
    'Show all links': 'Alle Links anzeigen',
    'Link {{index}}: ': 'Link {{index}}: ',
    'Successfully added nodes to clipboard.': 'Dokument in Ablage gespeichert.',
    'Successfully added node {{name}} to clipboard.':
      'Dokument {{name}} in Ablage gespeichert.',
    'Are you sure that you want to delete {{name}}? {{additionalText}}':
      'Sind Sie sicher, dass sie {{name}} löschen möchten? {{additionalText}}',
    'Node {{name}} contain references that will be deleted. Do you want to proceed?':
      'Dokument {{name}} hat Referenzkopien, die ebenfalls gelöscht werden. Wollen Sie fortfahren?',
    'Finish linking this node': 'Verlinken abschließen',
    'Cancel link': 'Link abbrechen',
    'Finish link': 'Link abschließen',
    'Insert cut': 'Einfügen',
    'Link name': 'Link Name',
    Yes: 'Ja',
    No: 'Nein',
    Open: 'Offen',
    'Insert questionnaire': 'Frage einfügen',
    'Update questionnaire': 'Frage aktualisieren',
    'question is required': 'Frage erforderlich',
    'Name of questionnaire node': 'Name der Frage',
    'Type your question here': 'Geben Sie Ihre Frage hier ein',
    'answer type is required': 'Antwort erforderlich',
    'Successfully added node to global linking process.':
      'Verlinken erfolgreich gestartet.',
    'Successfully deleted a link.': 'Link erfolgreich gelöscht.',
    'Successfully pinned node {{name}} to surface.':
      'Referenzkopie von {{name}} erfolgreich erstellt.',
    'Successfully linked text snippet to node.':
      'Textteil erfolgreich mit Dokument verlinkt.',
    'How would you answer the question?':
      'Wie würden Sie die Frage beantworten?',
    'Node was successfully auto saved and text snippet was added to global link zone.':
      'Dokument erfolgreich gespeichert und Verlinken gestartet.',
    'Enter snippet name': 'Textname eingeben',
    'Read only': 'schreibgeschützt',
    'Register for a CortLex account':
      'Registrieren Sie sich für einen CortLex Account',
    'Do you need a CortLex account?': 'Sie haben noch keinen CortLex Account?',
    'You already have a CortLex account?':
      'Sie haben bereits einen CortLex Account?',
    'Sign up for free': 'Registrieren',
    'Sign in': 'Einloggen',
    'Log in to your CortLex Account': 'In Ihr CortLex einloggen',
    'Remember my login on this computer': 'Login Daten merken',
    show: 'anzeigen',
    hide: 'ausblenden',
    'Your email has been successfully verified. Please login with your credentials.':
      'Ihre E-Mail Adresse wurde erfolgreich bestätigt. Bitte melden Sie sich mit Ihren Login-Daten an.',

    'Something went wrong, could not complete the operation':
      'Etwas ist schief gelaufen, der Vorgang konnte nicht abgeschlossen werden',
    // TODO translate

    'Document was successfully auto saved and text snippet was added to global link zone.':
      'Dokument wurde erfogreich gespeichert und der Snippet befindet sich in der Global Link Zone.',

    'Share this cell': 'Diese Zelle teilen',
    'Share cell': 'Zelle teilen',
    Sharing: 'Kollaboration',
    '(You)': '(Du)',
    'Enter email address': 'E-Mail Adresse eingeben',
    'At Last one email address is required':
      'Bitte zumindest eine E-Mail Adresse eingeben',
    'Emails contain invalid email format': 'E-Mail Format ungültig',
    'Successfully sent invitations': 'Einladung(en) erfolgreich gesendet',
    'Include sub cells': 'Unterzellen inkludieren',
    'this will share a total of {{count}}':
      'dies wird insgesamt {{count}} Zellen teilen',
    Owner: 'Urheber',
    Viewer: 'Betrachter',
    'Can view': 'Kann betrachten',
    'Successfully deleted node and removed access for {{name}} cell':
      'Zelle {{name}} erfolgreich gelöscht.',
    'By deleting cell {{name}} you will lose access.':
      'Indem du Zelle {{name}} löschst, wirst du Zugriff darauf verlieren',
    'Mark all as read': 'Alle als gelesen markieren',
    '{{count}} notifications': '{{count}} Nachrichten',
    Notifications: 'Nachrichten',
    'No notifications': 'Keine Nachrichten',
    'Notifications about your activity will show up here':
      'Nachrichten zu deiner Aktivität werden hier erscheinen',
    'Back to Cell': 'Zurück zur Zelle',
    'Successfully deleted invitation for {{email}}':
      'Einladung an {{email}} erfolgreich gelöscht',
    'Send invitations': 'Einladungen verschicken',
    'this will share every new sub cell created':
      'Dies gibt jede neu erstellte Unterzelle frei',
    'Successfully changed role for {{user}} to {{role}}':
      'Erfolgreich die Rolle für {{user}} zu {{role}} geändert',
    Admin: 'Admin',
    Editor: 'Bearbeiter',
    Filler: 'Ausfüller',
    Linker: 'Verbinder',
    'Filler-Linker': 'Ausfüller-Verbinder',
    'Restricted-Viewer': 'Eingeschränkter-Betrachter',
    'Your role on surface has been changed to {{role}}':
      'Ihre Rolle auf der Oberfläche wurde zu {{role}} geändert',
    'Your access to surface {{name}} has been revoked':
      'Ihr Zugriff auf die Oberfläche {{Name}} wurde widerrufen',
    'Save document': 'Dokument speichern',
    "You don't have permission to paste nodes on this surface":
      'Sie sind nicht berechtigt, Knoten in diese Zelle einzufügen',
    "Successfully copied surface {{name}}. It may take a while to copy {{name}} surface content. You will receive an update when it's done.":
      "Successfully copied surface {{name}}. It may take a while to copy {{name}} surface content. You will receive an update when it's done.",
  },
};
